import type { ComponentType } from 'react';

import type { UIFacet } from 'src/components/types/UIFacet';
import { DeliveryDateStrip, getDeliveryDateSummary } from './DeliveryDateStrip/DeliveryDateStrip';
import type { FacetOptionsProps } from './types';

/**
 * Bespoke controls keyed on facet key. A facet with no entry renders through the generic
 * single or multi component. A renderer must select by following each option's `href`
 * and hold no selection state, so URL sync, the request and the pills keep working unchanged.
 */
export const customRenderers: { [facetKey: string]: ComponentType<FacetOptionsProps> } = {
  'attributes.delivery_days': DeliveryDateStrip,
};

/**
 * Secondary text for a closed facet's header, keyed on facet key. It replaces the chosen
 * option's title, and a facet with no entry, or one that returns undefined, keeps that title.
 */
export const customSummaries: { [facetKey: string]: (facet: UIFacet) => string | undefined } = {
  'attributes.delivery_days': getDeliveryDateSummary,
};
